<section>
  <h3>Avalie esta loja</h3>

  <ngb-rating class="star" [max]="5" [(rate)]="starRating" [readonly]="false"></ngb-rating>

  <button (click)="rate()" >Concluir</button>
</section>
